import { AnswerType } from "../enums/AnswerType";

function pad(s: any) { return (s < 10) ? '0' + s : s; }

export const formatAnswer = (question: any) => {
    let formattedAnswer = question.answer;
    if (formattedAnswer !== "") {
        if (question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.ListBox || question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.RadioSelect || question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.NativeSelect) {
            let dropdownItem = question.answerList.filter((x: { value: any; }) => x.value === question.answer);
            formattedAnswer = dropdownItem[0].text;
        }

        if (question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.DatePicker) {
            var d = new Date(formattedAnswer);

            formattedAnswer = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
        }

        if (question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.Integer) {
            if (question.questionSetAnswerType.answerTypeName.toLowerCase() === "largemoney") {
                return <span>&pound;{Number(formattedAnswer).toLocaleString()}</span>;
            }
        }

        if (question.questionSetAnswerType.answerTypeBaseTypeID === AnswerType.Radio) {
            formattedAnswer = formattedAnswer === "1" ? "Yes" : "No";
        }
    }

    return <span>{formattedAnswer}</span>;
}